import React from 'react'
import Container from '../foundations/Container'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'
import styles from './MediaFeature.module.scss'

const MediaFeature = ({
  eyebrow,
  heading,
  body,
  secondaryHeading,
  secondaryBody,
  image,
  imageAlt,
  imagePosition = 'center',
  framed = false,
  reverse = false,
  tone = 'dark'
}) => (
  <section className={`${styles.section} ${styles[tone] || ''}`}>
    <Container className={`${styles.grid} ${reverse ? styles.reverse : ''} ${framed ? styles.framed : ''}`}>
      <Media
        picture={image?.picture}
        src={image?.src || image}
        alt={imageAlt}
        policy={MEDIA_POLICY_KEYS.SECTION_SPLIT}
        ratio='4 / 3'
        objectPosition={imagePosition}
        className={styles.media}
      />
      <div className={styles.copy}>
        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
        <h2>{heading}</h2>
        <div className={styles.body}>{body}</div>
        {secondaryHeading && (
          <div className={styles.secondary}>
            <h3>{secondaryHeading}</h3>
            <div className={styles.body}>{secondaryBody}</div>
          </div>
        )}
      </div>
    </Container>
  </section>
)

export default MediaFeature
